<template>
  <modal :show="show" @change="$emit('change',$event)" width="700">
    <template v-slot:header>
      <span>Уважаемый клиент!</span>
    </template>
    <template v-slot:main>
      <div class="modal-content">
        <div class="tes-text modal-content-text">
          Обращаем Ваше внимание, что при неоплате услуг того или иного поставщика Ваша
          задолженность по услуге данного поставщика перейдет на следующий расчетный период
        </div>
        <div class="tes-text-title modal-content-question">Продолжить?</div>
        <div class="modal-content-buttons">
          <v-btn class="green-button" @click="click(true)">Да</v-btn>
          <v-btn class="white-button" @click="click(false)">Нет</v-btn>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";

export default {
  name: "ModalPaymentByProvidersInfo",
  components: { Modal },
  model: {
    prop: "show",
    event: "change"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click(flag) {
      if (flag) {
        this.$emit("change", false);
        this.$emit("answer", true);
      } else {
        this.$emit("change", false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-content {
  padding: 25px 20px;

  &-text {
    margin-bottom: 20px;
    text-align: center;
  }

  &-question {
    margin-bottom: 20px;
    text-align: center;
  }

  &-buttons {
    display: flex;
    justify-content: center;
    @media screen and (max-width: 450px) {
      flex-wrap: wrap;
    }

    & * {
      margin: 5px;
    }
  }
}
</style>
